 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import ANTH_9781605507507_EPUB_C1_R1 from '@/components/Anth_9781605507507_epub_c1_r1'
 import SS_US_ADULT_SIGNUP_FRONT from '@/components/SS_US_adult_signup_front'
 import LOVE_1 from '@/components/love_1'
 import ANTH_9781605507507_EPUB_C2_R1 from '@/components/Anth_9781605507507_epub_c2_r1'
 import ANTH_9781605507507_EPUB_C3_R1 from '@/components/Anth_9781605507507_epub_c3_r1'
 import ANTH_9781605507507_EPUB_C4_R1 from '@/components/Anth_9781605507507_epub_c4_r1'
 import ANTH_9781605507507_EPUB_C5_R1 from '@/components/Anth_9781605507507_epub_c5_r1'
 import ANTH_9781605507507_EPUB_C6_R1 from '@/components/Anth_9781605507507_epub_c6_r1'
 import ANTH_9781605507507_EPUB_C7_R1 from '@/components/Anth_9781605507507_epub_c7_r1'
 import ANTH_9781605507507_EPUB_C8_R1 from '@/components/Anth_9781605507507_epub_c8_r1'
 import ANTH_9781605507507_EPUB_C9_R1 from '@/components/Anth_9781605507507_epub_c9_r1'
 import ANTH_9781605507507_EPUB_C10_R1 from '@/components/Anth_9781605507507_epub_c10_r1'
 import ANTH_9781605507507_EPUB_C11_R1 from '@/components/Anth_9781605507507_epub_c11_r1'
 import ANTH_9781605507507_EPUB_C12_R1 from '@/components/Anth_9781605507507_epub_c12_r1'
 import ANTH_9781605507507_EPUB_C13_R1 from '@/components/Anth_9781605507507_epub_c13_r1'
 import ANTH_9781605507507_EPUB_C14_R1 from '@/components/Anth_9781605507507_epub_c14_r1'
 import ANTH_9781605507507_EPUB_C15_R1 from '@/components/Anth_9781605507507_epub_c15_r1'
 import ANTH_9781605507507_EPUB_C16_R1 from '@/components/Anth_9781605507507_epub_c16_r1'
 import ANTH_9781605507507_EPUB_C17_R1 from '@/components/Anth_9781605507507_epub_c17_r1'
 import ANTH_9781605507507_EPUB_C18_R1 from '@/components/Anth_9781605507507_epub_c18_r1'
 import ANTH_9781605507507_EPUB_C19_R1 from '@/components/Anth_9781605507507_epub_c19_r1'
 import ANTH_9781605507507_EPUB_C20_R1 from '@/components/Anth_9781605507507_epub_c20_r1'
 import ANTH_9781605507507_EPUB_C21_R1 from '@/components/Anth_9781605507507_epub_c21_r1'
 import ANTH_9781605507507_EPUB_C22_R1 from '@/components/Anth_9781605507507_epub_c22_r1'
 import ANTH_9781605507507_EPUB_C23_R1 from '@/components/Anth_9781605507507_epub_c23_r1'
 import ANTH_9781605507507_EPUB_C24_R1 from '@/components/Anth_9781605507507_epub_c24_r1'
 import ANTH_9781605507507_EPUB_C25_R1 from '@/components/Anth_9781605507507_epub_c25_r1'
 import ANTH_9781605507507_EPUB_C26_R1 from '@/components/Anth_9781605507507_epub_c26_r1'
 import ANTH_9781605507507_EPUB_C27_R1 from '@/components/Anth_9781605507507_epub_c27_r1'
 import ANTH_9781605507507_EPUB_C28_R1 from '@/components/Anth_9781605507507_epub_c28_r1'
 import ANTH_9781605507507_EPUB_C29_R1 from '@/components/Anth_9781605507507_epub_c29_r1'
 import ANTH_9781605507507_EPUB_C30_R1 from '@/components/Anth_9781605507507_epub_c30_r1'
 import ANTH_9781605507507_EPUB_C31_R1 from '@/components/Anth_9781605507507_epub_c31_r1'
 import ANTH_9781605507507_EPUB_C32_R1 from '@/components/Anth_9781605507507_epub_c32_r1'
 import ANTH_9781605507507_EPUB_C33_R1 from '@/components/Anth_9781605507507_epub_c33_r1'
 import ANTH_9781605507507_EPUB_C34_R1 from '@/components/Anth_9781605507507_epub_c34_r1'
 import LOVE_2 from '@/components/love_2'
 import SS_US_ADULT_SIGNUP_BACK from '@/components/SS_US_adult_signup_back'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Anth_9781605507507_epub_c7_r1",
 			"name" : "Anth_9781605507507_epub_c7_r1",
 			"component" : ANTH_9781605507507_EPUB_C7_R1
 		},
 		{
 			"path" : "/Anth_9781605507507_epub_c8_r1",
 			"name" : "Anth_9781605507507_epub_c8_r1",
 			"component" : ANTH_9781605507507_EPUB_C8_R1
 		},
 		{
 			"path" : "/Anth_9781605507507_epub_c9_r1",
 			"name" : "Anth_9781605507507_epub_c9_r1",
 			"component" : ANTH_9781605507507_EPUB_C9_R1
 		},
 		{
 			"path" : "/Anth_9781605507507_epub_c10_r1",
 			"name" : "Anth_9781605507507_epub_c10_r1",
 			"component" : ANTH_9781605507507_EPUB_C10_R1
 		},
 		{
 			"path" : "/Anth_9781605507507_epub_c11_r1",
 			"name" : "Anth_9781605507507_epub_c11_r1",
 			"component" : ANTH_9781605507507_EPUB_C11_R1
 		},
 		{
 			"path" : "/Anth_9781605507507_epub_c12_r1",
 			"name" : "Anth_9781605507507_epub_c12_r1",
 			"component" : ANTH_9781605507507_EPUB_C12_R1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js